import type { ReactNode } from 'react';

interface Props {
  title: string;
  description?: string;
  actions?: ReactNode;
}

export function PageHeader({ title, description, actions }: Props) {
  return (
    <div className="flex items-start justify-between gap-4 mb-6">
      <div>
        <h1 className="text-[21px] font-semibold leading-tight -tracking-[0.01em] mb-1">
          {title}
        </h1>
        {description && <p className="text-[13.5px] text-text-2 m-0">{description}</p>}
      </div>
      {actions && <div className="flex items-center gap-2.5">{actions}</div>}
    </div>
  );
}

export function PageContainer({ children }: { children: ReactNode }) {
  return <div className="px-8 pt-7 pb-12 max-w-[1180px]">{children}</div>;
}

export function SectionLabel({ children }: { children: ReactNode }) {
  return (
    <div className="font-semibold text-[11.5px] uppercase tracking-[0.07em] text-text-3 mt-6 mb-3">
      {children}
    </div>
  );
}
